import SherloModule from './SherloModule';
function openStorybook() {
    return SherloModule.openStorybook();
}
export default openStorybook;
//# sourceMappingURL=openStorybook.js.map